module.exports = __webpack_public_path__ + "static/media/scratch_bg.74708229.jpeg";